
import { v4 as uuidv4 } from 'uuid';

export class UUIDUtils {
    static randomUUID(): string {
        return uuidv4();
    }
}